import React, { Component } from 'react';

export class FilterBar extends Component {

  state = {
    direction:true,
    activeFilter: 'best',
    resultFilter:""
  }


  handleFilter = byWhat => {

    if (this.state.activeFilter !== byWhat) {
      this.setState({ activeFilter: byWhat, direction: true });
      this.props.onFilterChange(byWhat, true, this.state.resultFilter);
      return;
    }

    var newDirection = !this.state.direction;

    this.setState({ direction: newDirection });

    this.props.onFilterChange(byWhat, newDirection, this.state.resultFilter);
  }

  showIndicator(state) {
    return state ? "fas fa-angle-down" : "fas fa-angle-up";
  }

  handleResultFilter = resultFilter => {

    const { direction, activeFilter } = this.state;

    this.setState({ resultFilter});

    this.props.onFilterChange(activeFilter, direction, resultFilter);
  }

  render() {
    return (<div className="container filter d-none d-sm-block mt-2">

      <div className="ml-1 d-inline-block"><span>Order {this.props.resultCount} results </span></div>

              <div className="d-inline-block" >
                <a onClick={() => this.handleFilter('best')} href="#" className="">By Best Match {this.state.activeFilter === 'best' && <i className={this.showIndicator(this.state.direction)} />}</a>
              </div>

      <div className="d-inline-block" >
                <a onClick={() => this.handleFilter('desc')} href="#" className="">By Description {this.state.activeFilter === 'desc' && <i className={this.showIndicator(this.state.direction)} />}</a>
              </div>
      <div className="d-inline-block" >
                <a onClick={() => this.handleFilter('price')} href="#" className="">By Price {this.state.activeFilter === 'price' && <i className={this.showIndicator(this.state.direction)} />}</a>
              </div>
      <div className="d-inline-block" >
                <a onClick={() => this.handleFilter('stock')} href="#" className="">By Stock {this.state.activeFilter === 'stock' && <i className={this.showIndicator(this.state.direction)} />}</a>
              </div>
      <div className="d-inline-block" >
                <div className="input-group input-group-sm">
                  <input type="text" className="form-control" placeholder="Filter results by.." value={this.state.resultFilter} onChange={e => this.handleResultFilter(e.currentTarget.value)} />
                  <div className="input-group-append">
            {this.state.resultFilter && <span className="input-group-text"><i className="fas fa-backspace clickable" onClick={() => this.handleResultFilter('')}></i></span>}
                  </div>
                </div>
              </div>


     
            
      
    </div>);
  }
}